(function () {
  'use strict';

  function normaliseTitle(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/’/g, "'")
      .replace(/\s+/g, ' ');
  }

  function rankTitle(title, fallbackIndex) {
    var normalised = normaliseTitle(title);

    if (normalised === 'motif worlds' || normalised === 'motiv worlds') return 0;
    if (normalised === 'exhibitions') return 1;
    if (normalised === "artist's selection") return 2;

    return 100 + fallbackIndex;
  }

  function reorderAtelirNavigation(root) {
    var context = root && root.querySelector ? root : document;
    var menuList = context.querySelector(
      'body.okd-style-atelir section.okd-world .okd-world__menu > ul'
    ) || document.querySelector(
      'body.okd-style-atelir section.okd-world .okd-world__menu > ul'
    );

    if (!menuList || menuList.dataset.kfaAtelirOrderReady === '1') return;

    var items = Array.prototype.slice.call(menuList.children).filter(function (item) {
      return item.tagName === 'LI';
    });

    if (items.length < 3) return;

    var ordered = items
      .map(function (item, index) {
        var topLevelLabel = item.querySelector(':scope > a');
        return {
          item: item,
          index: index,
          rank: rankTitle(topLevelLabel ? topLevelLabel.textContent : '', index)
        };
      })
      .sort(function (a, b) {
        return a.rank - b.rank || a.index - b.index;
      });

    ordered.forEach(function (entry) {
      menuList.appendChild(entry.item);
    });

    menuList.dataset.kfaAtelirOrderReady = '1';
  }

  function initialise() {
    reorderAtelirNavigation(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', function (event) {
    reorderAtelirNavigation(event.target || document);
  });
})();
